const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_auth/_oauth/oauth-qrcode.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { OAuthQrCodeSearchSchema } from '@apps/main/features/auth/pages/oauth-qrcode-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/_oauth/oauth-qrcode')({
  validateSearch: OAuthQrCodeSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});